
import {xsrfHeaderName} from './request'
import Cookie from 'js-cookie'

export function getToken() {
  return Cookie.get(xsrfHeaderName)
}